import { useEffect, useState } from "react";

const LIGHT_COUNT = 20;
const COLORS = ["#ff3333", "#33ff33", "#3333ff", "#ffff33", "#ff33ff", "#33ffff"] as const;

export const ChristmasLights = () => {
  const [lights, setLights] = useState<number[]>([]);
  const currentMonth = new Date().getMonth();
  const isDecember = currentMonth === 11;

  useEffect(() => {
    if (!isDecember) {
      return;
    }

    const positions = Array.from({ length: LIGHT_COUNT }, (_, i) => i);
    setLights(positions);

    const interval = window.setInterval(() => {
      setLights(prev => [...prev]);
    }, 100);

    return () => window.clearInterval(interval);
  }, [isDecember]);

  if (!isDecember) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] pointer-events-none h-16 w-full opacity-80">
      <svg
        width="100%"
        height="64"
        viewBox="0 0 1920 64"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M 0,10 Q 96,20 192,10 T 384,10 T 576,10 T 768,10 T 960,10 T 1152,10 T 1344,10 T 1536,10 T 1728,10 T 1920,10"
          stroke="#2d3748"
          strokeWidth="2"
          fill="none"
        />

        {lights.map((_, index) => {
          const x = (index * 1920) / LIGHT_COUNT + 48;
          const yBase = index % 2 === 0 ? 10 : 15;
          const y = yBase + Math.sin((Date.now() / 1000 + index) * 2) * 2;
          const color = COLORS[index % COLORS.length];
          const glowIntensity = (Math.sin((Date.now() / 500 + index) * 3) + 1) / 2;

          return (
            <g key={index}>
              <line x1={x} y1={yBase} x2={x} y2={y + 15} stroke="#2d3748" strokeWidth="1" />
              <ellipse
                cx={x}
                cy={y + 20}
                rx={8}
                ry={10}
                fill={color}
                opacity={0.3 + glowIntensity * 0.3}
                filter="url(#glow)"
              />
              <ellipse
                cx={x}
                cy={y + 20}
                rx={5}
                ry={7}
                fill={color}
                opacity={0.7 + glowIntensity * 0.3}
              />
              <ellipse cx={x - 1} cy={y + 18} rx={2} ry={3} fill="white" opacity={0.6} />
              <rect x={x - 3} y={y + 14} width={6} height={4} fill="#888" rx={1} />
            </g>
          );
        })}

        <defs>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default ChristmasLights;
